import { createSelector } from 'reselect';
import get from 'lodash/get';
import {
  metricSelector,
  filterSelector,
  intervalPayloadSelector,
} from '@store/errorDiagnostics/base/selectors';
import { getIntervalByGranularity } from '@utils/granularity';
import commonSelector from '@store/common/selectors';
import featureNames from '@utils/featureToggle/constants';
import { granularity as getGranularity } from '@utils';
import { DATASET } from '@utils/constants';
import { getErrorMetricInfo } from '@utils/dimension';
import { SCOPE } from './types';

const selector = (state) => get(state, SCOPE);

export default selector;

export const payloadSelector = createSelector(
  metricSelector,
  intervalPayloadSelector,
  filterSelector,
  commonSelector,
  (metric, interval, filter, commonStore) => {
    if (!metric) {
      return null;
    }

    const metricInfo = getErrorMetricInfo(metric);
    const metrics = [metricInfo.baseline, metricInfo.primary];

    const granularity = getGranularity({
      from: interval.from,
      to: interval.to,
      minuteGranularity: true,
    });

    const { from, to } = getIntervalByGranularity(interval, granularity);

    const { features } = commonStore;
    const errorCodesLimit = features[featureNames.ERROR_CODES_LIMIT];

    return {
      queries: [
        {
          type: 'group-by',
          dataset: DATASET,
          metrics,
          interval: `${from}/${to}`,
          granularity,
          filter: filter.rule,
          limit: errorCodesLimit,
          groupBy: [metricInfo.dimension],
          orderBy: 'desc',
          sortBy: [
            {
              metric: metricInfo.primary,
              order: 'desc',
            },
          ],
          options: { withTotals: true },
        },
      ],
    };
  },
);
